let language = {
    BILLING_METHOD_FULL_NAME :"Full Name:",
    BILLING_METHOD_COMPANY :"Company:",
    BILLING_METHOD_COUNTRY_REGION :"Country/Region:",
    BILLING_METHOD_PHONE :"Phone:",
    BILLING_METHOD_POSTAL_CODE :"Postal Code:",
    BILLING_METHOD_ADDRESS1 :"Address1:",
    BILLING_METHOD_ADDRESS2 :"Address2:",
    BILLING_METHOD_CITY_TOWN :"City/Town:",
    BILLING_METHOD_CAN_BE_EMPTY: "Can't be empty.",
    BILLING_METHOD_NO_RESULTS_MATCH: "No results match",
    BILLING_METHOD_PHONE_FORMAT_INVALID: "Phone format invalid.",
    BILLING_METHOD_SELECT_FRON_ADDRESS_BOOK: "Select From Address Book",

};

export { language }
